import { TalentBiddingsVuex } from "@/@talent/store/biddings.vuex";
import {
  AccountVuex,
  AccountVuexState,
} from "@/shared/vuex/store/account.vuex";
import { createStore } from "vuex";
import { createLogger } from "vuex";
import { TalentModalsVuex, TalentModalsVuexState } from "./modals.vuex";
import { TalentOpportunitiesVuex } from "./opportunities.vuex";

export interface TalentPlatformState {
  account: AccountVuexState;
  modals: TalentModalsVuexState,
}
/**
 *
 */
export const TalentStore = createStore<TalentPlatformState>({
  plugins: [createLogger({})],
  modules: {
    account: AccountVuex as any,
    modals: TalentModalsVuex as any,
    biddings: TalentBiddingsVuex as any,
    opportunities: TalentOpportunitiesVuex as any
  },
});

export default TalentStore;
